import { Col, Flex, Form, Row, Typography } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useMemo, useState } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  BODY_HEIGHT,
  HEADER_HEIGHT,
  INPUT_FIELD_HEIGHT,
} from 'src/app/features/feature-transaction-rules/add-new-issued-check/index.constant'
import CustomDatePicker from 'src/app/shared/components/common/date-picker'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'

interface DelayedClientActivationProps {
  control: any
  disabled?: boolean
}

function DelayedClientActivation(props: Readonly<DelayedClientActivationProps>) {
  const { control } = props
  const { t } = useTranslation()
  const [isOpenPopupPicker, setIsOpenPopupPicker] = useState(false)
  const [popupPickerPosition, setPopupPickerPosition] = useState({
    top: 0,
    bottom: 0,
    body: 0,
  })

  const disabled = useMemo(() => {
    return props.disabled ?? false
  }, [props.disabled])

  useEffect(() => {
    const body = document.querySelector('body')
    const bodyScreenHeight = body?.getBoundingClientRect()?.height ?? 0
    const topIssuedDate = HEADER_HEIGHT + BODY_HEIGHT
    const bottomIssuedDate = bodyScreenHeight - topIssuedDate - INPUT_FIELD_HEIGHT

    setPopupPickerPosition({
      top: topIssuedDate,
      bottom: bottomIssuedDate,
      body: bodyScreenHeight,
    })
  }, [isOpenPopupPicker])

  return (
    <Flex vertical style={{ paddingBottom: '24px', flex: 1 }}>
      <Typography.Text style={{ fontSize: '18px', fontWeight: '700', lineHeight: '28px', paddingBottom: '4px' }}>
        {'Delayed Client Activation'}
      </Typography.Text>

      <Flex vertical style={{ border: `1px solid ${colorBorderDisabled}`, padding: '16px', borderRadius: '16px' }}>
        <Row gutter={24}>
          <Col span={24} md={12}>
            <Form.Item>
              <Controller
                control={control}
                name='activationDate'
                render={({ field, fieldState }) => (
                  <CustomDatePicker
                    label={'Activation Start Date'}
                    minDate={dayjs().add(1, 'day')}
                    placeholder={'Select Activation Start Date'}
                    value={field.value}
                    onChange={field.onChange}
                    error={fieldState.error}
                    placement='bottomLeft'
                    popupClassName='add-new-issued-popup'
                    onClick={() => {
                      setIsOpenPopupPicker(true)
                    }}
                    className='issued-date-picker'
                    disabled={disabled}
                  />
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Flex>
    </Flex>
  )
}

export default DelayedClientActivation
